import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { IonicModule } from '@ionic/angular'
import { TranslateModule } from '@ngx-translate/core'

@Component({
  selector: 'app-printer-recovery',
  imports: [IonicModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (objProgress) {
      <div class="recovery-backdrop">
        <section role="dialog" aria-modal="true" aria-labelledby="printer-recovery-status">
          <p id="printer-recovery-status" role="status">{{ strMessageKey | translate }}</p>
          <div class="recovery-progress">
            <ion-progress-bar [value]="objProgress.intPercent / 100"
              [attr.aria-label]="strMessageKey | translate"></ion-progress-bar>
            <span>{{ objProgress.intPercent }}%</span>
          </div>
        </section>
      </div>
    }
  `,
  styles: [`
    .recovery-backdrop {
      position: fixed;
      inset: 0;
      z-index: 100000;
      display: grid;
      place-items: center;
      background: rgb(0 0 0 / 45%);
    }
    section {
      width: min(28rem, 90vw);
      padding: 1.5rem;
      border-radius: 0.75rem;
      background: var(--ion-background-color, #fff);
      color: var(--ion-text-color, #000);
      box-shadow: 0 0.5rem 2rem rgb(0 0 0 / 25%);
    }
    p { margin: 0 0 1.25rem; }
    .recovery-progress { display: flex; align-items: center; gap: 1rem; }
    ion-progress-bar {
      flex: 1;
      height: 8px;
      border-radius: 4px;
      overflow: hidden;
      --background: #cbd5e1;
      --progress-background: var(--ion-text-color, #111827);
    }
    span { min-width: 4ch; text-align: right; font-variant-numeric: tabular-nums; }
  `]
})
export class PrinterRecoveryComponent {
  /** Progress of the running recovery, or null when no recovery is in progress. */
  @Input() objProgress: { intPercent: number } | null = null
  /** Translation key describing which printer connection is being recovered. */
  @Input() strMessageKey = 'ThermalPrinterService.reconnectingBluetooth'
}
